import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-store-filter',
  templateUrl: './store-filter.component.html',
  styleUrls: ['./store-filter.component.css']
})

export class StoreFilterComponent implements OnInit {
  @Input() data: any;
  public categoryList;

  public showOptionsArr = [];
  public selectedOptionIndex = undefined;
  public prevSelectedFilter = '';
  public selectedMainFilterIndex = undefined;
  storeComponentInstance;
  selectedFirstLevelClassification;
  selectedFirstLevelClassification_id;
  listOfClasification;
  comp;
  storeBooksCopy;
  selectedLanguageInd;
  priceListArr = [
    {
      englishName:'Free',
      arabicName:'Free',    
    },{
      englishName:'Paid',
      arabicName:'Paid',    
    }
  ];

  typeListArr = [
    {
      englishName:'EBE',
      arabicName:'EBE',    
    },{
      englishName:'ELE',
      arabicName:'ELE',    
    }
  ];

  constructor() { }

  ngOnInit() {
    this.selectedLanguageInd = Number(localStorage.selectedLanguageInd)
    this.storeComponentInstance = this.data.popupProps.curComp;
    this.categoryList = this.storeComponentInstance.firstLevelFilterStores;
    this.storeBooksCopy = JSON.parse(JSON.stringify(this.storeComponentInstance.subBookStoresCopy));
    this.comp = this.data.popupProps.curComp;
    this.listOfClasification = this.comp.storeContent.getStores.storeDetailClassifications;
    if (this.categoryList[0].prefix.name != 'All') {
      this.selectedFirstLevelClassification_id = this.categoryList[0].prefix.id;
    }
  }

  ngOnDestroy(){
    Object.keys(this).map(k => {
    this[k] = null;
    })
    }

  showOptionsArrList(index, item) {
    var self = this;
    // if (item.id == this.categoryList[1].id && !this.selectedFirstLevelClassification_id) {
    //   return;
    // }
   
if(item.id  == 'PRICE' || item.id == 'TYPE'){
  if(item.id == 'PRICE')
  this.showOptionsArr = this.priceListArr;

  if(item.id == 'TYPE')
  this.showOptionsArr = this.typeListArr;

this.prevSelectedFilter = item;
this.selectedOptionIndex = _.findIndex(this.showOptionsArr, function (o) { return o.englishName == item.prefix.name; });
  return;
}

if(item.id == 'AUTHOR'){
  let authors = [];
  let allBooksData = JSON.parse(JSON.stringify(this.storeBooksCopy))
  for(var i = 0;i < allBooksData.length;i++){
    authors.push({englishName:allBooksData[i].author,
      arabicName:allBooksData[i].author})
  }
  // authors = _.uniq(authors);
  authors =  _.uniqBy(authors, 'englishName');
  this.showOptionsArr = authors;
  this.prevSelectedFilter = item;
  this.selectedOptionIndex = _.findIndex(this.showOptionsArr, function (o) { return o.englishName == item.prefix.name; });
  return;
}

    var bookTypes = this.comp.bookTypes;
    var selTabIndex = this.comp.selTabIndex;
    this.selectedFirstLevelClassification = item.id;

    if (item.id != this.categoryList[1].id) {
      this.showOptionsArr = _.filter(this.listOfClasification, function (filter) { return filter.storeDetailGroupId == bookTypes[selTabIndex].storeDetailGroupId && filter.type == item.id && filter.parentClassificationId == '' });
    }
    else {

      if(self.selectedFirstLevelClassification_id){
        this.showOptionsArr = _.filter(this.listOfClasification, function (filter) { return filter.storeDetailGroupId == bookTypes[selTabIndex].storeDetailGroupId && filter.type == item.id && filter.parentClassificationId == self.selectedFirstLevelClassification_id });
      }else{
        this.showOptionsArr = _.filter(this.listOfClasification, function (filter) { return filter.storeDetailGroupId == bookTypes[selTabIndex].storeDetailGroupId && filter.type == item.id});
      }      
    }
    this.showOptionsArr = _.uniqBy(this.showOptionsArr, 'classificationId');
    this.selectedOptionIndex = _.findIndex(this.showOptionsArr, function (o) { return o.englishName == item.prefix.name; });
    this.prevSelectedFilter = item;
    this.selectedMainFilterIndex = index;
  }


  backToMainFilter() {

    document.getElementsByClassName("globalpopup")[0]['style'].height = "auto";
    this.showOptionsArr = [];
    // this.selectedMainFilterIndex = undefined;
  }

  updateSelectedOptions(index, name) {

    document.getElementsByClassName("globalpopup")[0]['style'].height = "auto";
    this.selectedOptionIndex = index;

    var comp = this.data.popupProps.curComp;
    var self = this;

if(!name.classificationId){
  this.updateUserRelatedFilterData(name);
  return;
}

    var temp = _.filter(this.listOfClasification
      , function (filter) { return filter.parentClassificationId == name.classificationId && filter.type == self.selectedFirstLevelClassification });
    if (temp.length) {
      this.showOptionsArr = temp;
    } else {
      if (this.selectedFirstLevelClassification == this.categoryList[0].id) {
        if (this.selectedFirstLevelClassification_id != name.classificationId) {
          this.categoryList[1].prefix.name = "All";
          this.categoryList[1].prefix.id = "";
        }
        this.selectedFirstLevelClassification_id = name.classificationId;

      }
      this.prevSelectedFilter['prefix'].name = name.englishName;
      this.prevSelectedFilter['prefix'].id = name.classificationId;
    }

    this.updateStoreContent()

  }
  updateUserRelatedFilterData(name){
if(this.prevSelectedFilter['englishName'] == 'PRICE'){
let ind = _.findIndex(this.categoryList, function (o:any) { return o.id == 'PRICE'; });
this.categoryList[ind].prefix.name = name.englishName;
// this.categoryList[ind].prefix.id = name.englishName;

}
else if(this.prevSelectedFilter['englishName'] == 'AUTHOR'){
  let ind = _.findIndex(this.categoryList, function (o:any) { return o.id == 'AUTHOR'; });
  this.categoryList[ind].prefix.name = name.englishName;
}
else{
  let ind = _.findIndex(this.categoryList, function (o:any) { return o.id == 'TYPE'; });
  this.categoryList[ind].prefix.name = name.englishName;
}
this.updateStoreContent()
  }

  isSubFilterAvailable(item) {

    var showOptionsArr = _.filter(this.listOfClasification, function (filter) { return filter.parentClassificationId == item.classificationId });
    if (showOptionsArr.length) {
      return true;
    } else {
      return false;
    }
  }

  updateStoreContent() {
    let self = this;
    var selectedOptions = _.filter(this.categoryList, function (opt) {
      if (opt.prefix.id != '') {
        return opt.prefix.id
      }
    });
    var filterIds = [];
    for (var i = 0; i < selectedOptions.length; i++) {
      filterIds.push(selectedOptions[i]['prefix'].id);
    }

    var matchedBooks = [];
    this.storeComponentInstance.subBooksStore = JSON.parse(JSON.stringify(this.storeBooksCopy));
    if (!filterIds.length && this.categoryList[3].prefix.name == 'All' && this.categoryList[4].prefix.name == 'All' &&this.categoryList[5].prefix.name == 'All') {
      this.storeComponentInstance.subBooksStore = JSON.parse(JSON.stringify(this.storeBooksCopy));
      return;
    }
    if(!filterIds.length && this.categoryList[3].prefix.name != 'All'){
     this.updatePriceListFilterForBooks(this.storeComponentInstance.subBooksStore)
      
    }
    if(!filterIds.length && this.categoryList[4].prefix.name != 'All'){
      this.updateTypeFilterForBooks(this.storeComponentInstance.subBooksStore)     
    }
    if(!filterIds.length && this.categoryList[5].prefix.name != 'All'){
      this.storeComponentInstance.subBooksStore = _.filter(this.storeComponentInstance.subBooksStore, function(o) { return (o.author == self.categoryList[5].prefix.name); });         
    }

      if(!filterIds.length &&(this.categoryList[3].prefix.name != 'All' || this.categoryList[4].prefix.name != 'All' || this.categoryList[5].prefix.name != 'All')){
        return;
      }

    for (var i = 0; i < this.storeBooksCopy.length; i++) {

      var isMapped = this.MappingBooks(this.storeBooksCopy[i].classificationIds, filterIds);

      if (isMapped) {
        matchedBooks.push(this.storeBooksCopy[i]);
        // matchedBooks = _.uniq(matchedBooks);
       matchedBooks =  _.uniqBy(matchedBooks, 'publishId');
      }

    }

    this.storeComponentInstance.subBooksStore = matchedBooks;
    if(this.categoryList[3].prefix.name != 'All'){
      this.updatePriceListFilterForBooks(this.storeComponentInstance.subBooksStore)
    }
    if(this.categoryList[4].prefix.name != 'All'){
      this.updateTypeFilterForBooks(this.storeComponentInstance.subBooksStore)
    }

    if(this.categoryList[5].prefix.name != 'All'){
      this.storeComponentInstance.subBooksStore = _.filter(this.storeComponentInstance.subBooksStore, function(o) { return (o.author == self.categoryList[5].prefix.name); });         
    }
  }

  MappingBooks(classificationIds, arr) {
    if (0 === arr.length) {
      return false;
    }
    return arr.every(function (value) {
      return (classificationIds.indexOf(value) >= 0);
    });

  };

  selectAllOption() {
    this.prevSelectedFilter['prefix'].name = 'All';
    this.prevSelectedFilter['prefix'].id = "";
    this.updateStoreContent();
    this.selectedOptionIndex = undefined
  }

  updatePriceListFilterForBooks(data){
    if(this.categoryList[3].prefix.name == 'Free'){
      this.storeComponentInstance.subBooksStore = _.filter(data, function (opt) {
        return (opt.price == 0) 
      });
      }else{
        this.storeComponentInstance.subBooksStore = _.filter(data, function (opt) {
          return (opt.price != 0) 
        });
      }
  }

  updateTypeFilterForBooks(data){
    if(this.categoryList[4].prefix.name == 'EBE'){
      this.storeComponentInstance.subBooksStore = _.filter(data, function (opt) {
        return (opt.type == 'PDF') 
      });
      }else{
        this.storeComponentInstance.subBooksStore = _.filter(data, function (opt) {
          return (opt.type != 'PDF') 
        });
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/store-filter/store-filter.component.ts